import React, { useRef, useEffect } from 'react'
import { refreshToken, inactivityLogout } from '../redux/actions/auth'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import moment from 'moment'

// Session Toast config information
const sessionToastConfig = Swal.mixin({
  position: 'top',
  showConfirmButton: true,
  timer: 300000,
  timerProgressBar: true,
  customClass: 'swal-margin-top'
})

const SessionResponse = (props) => {
  // Moment value from API returned token
  const { expiration } = props

  const dispatch = useDispatch()

  // Timeout will be cleared everytime the redux storage is updated
  const intervalRef = useRef()
  const expirationRef = useRef()
  useEffect(() => {
    // console.log('expiration update')
    // console.log(expiration)
    if (!expiration || isNaN(parseInt(expiration)) || expiration === 0) { return false }
    // console.log('continuing')
    expirationRef.current = expiration
    // give ourselves five more minutes for the display
    // Get the difference in seconds
    const now = moment().valueOf()
    const nowMoment = moment(expiration).subtract(5, 'm').valueOf()
    // const expMoment = moment(expiration).valueOf()
    // console.log(nowMoment)

    const setActiveTimeout = () => {
      if (nowMoment && !isNaN(parseInt(nowMoment)) && now < nowMoment) {
        const ms = nowMoment - now
        // console.log(ms)
        const interval = setTimeout(function () { checkActive() }, ms)
        intervalRef.current = interval
      } else {
        // console.log(nowMoment)
        // console.log(now)
        dispatch(inactivityLogout())
      }
    }

    setActiveTimeout()

    // TO-DO: check the active boolean first, if false, fire notification to check active. IF true, refreshToken()
    const checkActive = () => {
      sessionToastConfig.fire({
        title: 'Are you there?',
        html: 'You will be logged out after five minutes of inactivity. You may resume by dismissing this message.',
        timer: 300000
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.timer) {
          return dispatch(inactivityLogout())
        } else {
          dispatch(refreshToken())
          return setActiveTimeout()
        }
      })
    }

    return () => {
      clearTimeout(intervalRef.current)
      expirationRef.current = null
    }
  }, [dispatch, expiration])

  return (
    <></>
  )
}

export default SessionResponse
